VjsAdmin.AdminEtxFailedEmails = (() => {
    const $table = $('#etx-failed-emails-table');

    const init = () => {
        initFailedEmailsTable();
        new Main();
    };

    const Main = VjsUtility.Controller.extend({
        events: {
            'click .remove-record': 'removeRecord',
            'click .show-attachments-json': 'showAttachments',
            'click .show-payload-json': 'showPayload',
        },
        removeRecord(e) {
            const $el = $(e.currentTarget);
            const id = $el.data('id');

            if (!window.confirm('Are you sure you want to remove this record?')) {
                return;
            }

            $el.parent().html('deleting...');

            const req = new VjsUtility.Request();
            req.delete(Slim.Router.pathFor('admin.etx.delete.failed.emails', { id }))
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully removed record!',
                        time: 4000,
                    });
                })
                .fail(() => {
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        showAttachments(e) {
            const $el = $(e.currentTarget);
            const json = $el.data('attachments');

            VjsUtility.Popup.init({
                title: 'Attachments JSON Data',
                templateUrl: '/assets/templates/admin-tools/etx/attachments_json.html',
                data: { json },
            });
        },
        showPayload(e) {
            const $el = $(e.currentTarget);
            const json = $el.data('payload');

            console.log(json);

            VjsUtility.Popup.init({
                title: 'Payload JSON Data',
                templateUrl: '/assets/templates/admin-tools/etx/payload_json.html',
                data: { json },
            });
        },
    });

    const initFailedEmailsTable = () => {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#etx-failed-emails-table',
            formatNoMatches() {
                return 'No failed ETX emails in log.';
            },
            idField: 'id',
            showRefresh: true,
            showColumns: true,
            pagination: true,
            sidePagination: 'server',
            pageSize: 50,
            search: true,
            method: 'get',
            sortName: 'id',
            icons: {
                refresh: 'fa-refresh',
            },
            url: Slim.Router.pathFor('admin.etx.failed.emails'),
            columns: [
                {
                    title: 'Subject',
                    field: 'subject',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Body',
                    field: 'body',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Number of Attachments',
                    field: 'num_attachments',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    width: 20,
                },
                {
                    title: 'Date',
                    field: 'created_at',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    width: 200,
                },
                {
                    title: 'Actions',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    width: 100,
                    sortable: false,
                    formatter(value, row) {
                        return `<a class='btn btn-primary d-block remove-record' data-id='${row.id}'>Remove Log</a>
                                <a class="btn btn-primary d-block margin-top-5 margin-bottom-5 show-attachments-json" data-attachments='${row.attachments_json}'>Show Attachments</a>
                                <a class="btn btn-primary d-block show-payload-json" data-payload='${row.full_payload_json}'>Show Full Payload</a>`;
                    },
                },
            ],
            responseHandler(res) {
                return {
                    total: res.total ? res.total : 0,
                    rows: res.data,
                };
            },
        });
    };

    return {
        init,
    };
})();
